import { LeftArrow } from "../../compoments/icons/LeftArrow";

// Reusable SkipLogin component
const SkipLogin = ({setActiveStep}) => (
  <div className="skipLogin">
    <div onClick={()=>setActiveStep(5)}>
      <span style={{ textDecoration: "underline" }}>Skip to Login</span>{" "}
      <span className="ms-2">
        <LeftArrow />
      </span>
    </div>
  </div>
);

export default SkipLogin